import { useTags } from 'features/tags';
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigationSectionLayout } from 'shared/components/ui/navigation-section-layout';

import { AddTagButton } from './add-tag-button';
import * as Styled from './tags.style';
import { TagsList } from './tags-list';

export const TagContent: React.FC = () => {
  const { t } = useTranslation();
  const tags = useTags();

  return tags.length ? (
    <Suspense>
      <TagsList />
    </Suspense>
  ) : (
    <Styled.EmptyDescription>
      {t('general.menu.navigation.tags.empty')}
    </Styled.EmptyDescription>
  );
};

export const Tags: React.FC = () => {
  const { t } = useTranslation();

  return (
    <NavigationSectionLayout
      label={t('general.menu.navigation.tags')}
      initialOpen={true}
      actions={[<AddTagButton />]}
    >
      <Suspense>
        <TagContent />
      </Suspense>
    </NavigationSectionLayout>
  );
};
